import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ConfigBase } from '../../models/config-base.model';

@Component({
    selector: 'lex-config',
    templateUrl: './config.component.html',
    styleUrls: ['./config.component.scss'],
    standalone: false
})
export class ConfigComponent implements OnChanges {

  @Input() configs: ConfigBase[];
  @Output() updatedConfig: EventEmitter<ConfigBase> = new EventEmitter<ConfigBase>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes.configs && this.configs)
      this.configs.sort(this.compare);
  }

  onChangeSlide(ob: MatSlideToggleChange): void {
    const matSlideToggle: MatSlideToggle = ob.source;
    this.updatedConfig.emit({ configTypeId: matSlideToggle.id, type: null, value: matSlideToggle.checked.toString() });
  }

  onChangeText(event: any): void {
    this.updatedConfig.emit({ configTypeId: event.target.id, type: null, value: event.target.value });
  }

  // Sort returning configs by DataType to have the slide Toggles above the text on display.
  compare(a: ConfigBase, b: ConfigBase) {
    const typeA = a.type.dataType;
    const typeB = b.type.dataType;

    if (typeA > typeB)
      return 1;
    if (typeA < typeB)
      return -1;

    return 0;
  }
}
